import { FinancialData, parseFinancialDataResponse } from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export const getFinancialData = async (appId: number): Promise<FinancialData> => {
  return APIClient.get(`/uw/${appId}/financial_data`).then((resp: any) => {
    return parseFinancialDataResponse(resp.financial_data);
  });
};

export const updateFinancialData = async (
  appId: number,
  data: FinancialData,
): Promise<FinancialData> => {
  return APIClient.post(`/uw/${appId}/financial_data`, {
    ...data,
    loan_application_id: appId,
  }).then((resp: any) => {
    return parseFinancialDataResponse(resp.financial_data);
  });
};
